export enum TachographWeeklyRestType {
  REGULAR = 'regular',
  REDUCED = 'reduced',
}
